// src/components/common/Navigation.tsx
// Navigation bar for all pages

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Users, Car, UserCircle, Shield, ClipboardCheck } from 'lucide-react';
import './Navigation.css';

const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-brand" onClick={() => navigate('/dashboard')}>
          <Shield size={24} />
          <span>Admin Panel</span>
        </div>

        <div className="nav-links">
          <button
            onClick={() => navigate('/dashboard')}
            className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}
          >
            <Home size={20} />
            <span>Dashboard</span>
          </button>

          <button
            onClick={() => navigate('/users')}
            className={`nav-link ${isActive('/users') ? 'active' : ''}`}
          >
            <Users size={20} />
            <span>All Users</span>
          </button>

          <button
            onClick={() => navigate('/drivers')}
            className={`nav-link ${isActive('/drivers') ? 'active' : ''}`}
          >
            <Car size={20} />
            <span>Drivers</span>
          </button>

          <button
            onClick={() => navigate('/passengers')}
            className={`nav-link ${isActive('/passengers') ? 'active' : ''}`}
          >
            <UserCircle size={20} />
            <span>Passengers</span>
          </button>

          <button
            onClick={() => navigate('/onboarding')}
            className={`nav-link ${isActive('/onboarding') || location.pathname.startsWith('/onboarding/') ? 'active' : ''}`}
          >
            <ClipboardCheck size={20} />
            <span>Onboarding</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;